export const GET_MATERIAL_REQUEST = 'GET_MATERIAL_REQUEST';
export const GET_MATERIAL_DATA = 'GET_MATERIAL_DATA';
export const GET_MATERIAL_ERROR = 'GET_MATERIAL_ERROR';

export const CREATE_MATERIAL_REQUEST = 'CREATE_MATERIAL_REQUEST';
export const CREATE_MATERIAL_DATA = 'CREATE_MATERIAL_DATA';
export const CREATE_MATERIAL_ERROR = 'CREATE_MATERIAL_ERROR';

export const UPDATE_MATERIAL_REQUEST = 'UPDATE_MATERIAL_REQUEST';
export const UPDATE_MATERIAL_DATA = 'UPDATE_MATERIAL_DATA';
export const UPDATE_MATERIAL_ERROR = 'UPDATE_MATERIAL_ERROR';

export const DELETE_MATERIAL_REQUEST = 'DELETE_MATERIAL_REQUEST';
export const DELETE_MATERIAL_DATA = 'DELETE_MATERIAL_DATA';
export const DELETE_MATERIAL_ERROR = 'DELETE_MATERIAL_ERROR';